import React, { useState, useEffect } from 'react';
import './dashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard-container">
    </div>
  );
};

export default Dashboard;